import React, { useContext, useRef, useState } from "react";
import { Card, CardBody, Row } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import UploadAttachments from "./UploadAttachments";
import { failureToast } from "../../../../common/utils/methods/toasterFunctions/function";
import AddMaterialTableV2 from "./AddMaterialTableV2";
import { accessibleIdList } from "./helper";
import { UserDetails } from "appContext";


const SelectMaterialForm = ({
  selectedMaterials,
  setSelectedMaterials,
  selectedNonBarcodedMaterials,
  setSelectedNonBarcodedMaterials,
  form,
  setFormHandler,
  issueStockHandler,
  loading,
  setLoading,
  isAllTransactionDetailsFilled,
  isDlp,
}) => {
  const listRef = useRef();
  const data = useContext(UserDetails);
  const isMaterialSelected = (selectedMaterials) => {
    if (selectedMaterials.length === 0) return true;
    if (selectedMaterials.length > 0) {
      const material = selectedMaterials[0];
      if (!material?.materialId || !material?.quantity) return true;
      return false;
    }
  };

  const saveRowHandler = (data, barCodes = [], index) => {
    const tempRows = [...selectedMaterials];
    const { id, materialId, qty, availableCount } = data;
    const barcodeList = barCodes.slice(0, qty);
    tempRows[index] = {
      ...materialId,
      id,
      barcodeList,
      quantity: qty,
      availableCount,
      qty: qty,
      openForm: false,
    };
    setSelectedMaterials(tempRows);
  };

  const saveRowNonBarcodedHandler = (data, barCodes = [], index) => {
    const tempRows = [...selectedNonBarcodedMaterials];
    const { id, materialId, qty, availableCount } = data;
    const barcodeList = barCodes.slice(0, qty);
    tempRows[index] = {
      ...materialId,
      id,
      barcodeList,
      quantity: qty,
      availableCount,
      qty: qty,
      openForm: false,
    };
    setSelectedNonBarcodedMaterials(tempRows);
  };

  const updateRowHandler = (data, barCodes = []) => {
    const { id, materialId, quantity, availableCount } = data;
    const barcodeList = barCodes.slice(0, quantity);
    // find material id index
    const index = selectedMaterials.findIndex(
      (item) => item?.materialId === materialId
    );
    if (index === -1) return false;
    const tempMaterials = [...selectedMaterials];
    tempMaterials[index] = {
      ...materialId,
      id,
      barcodeList,
      quantity,
      qty: barCodes.length,
      availableCount,
    };
    setSelectedMaterials(tempMaterials);
  };

  const deleteHandler = (rowData) => {
    setSelectedMaterials(
      selectedMaterials.filter(
        (item) => item?.materialId !== rowData?.materialId
      )
    );
  };
  const isAnyFormOpen = (isBarcoded=false) => {
    const isAnyFormOpen = isBarcoded?
    selectedNonBarcodedMaterials.some((item) => item?.openForm):
    selectedMaterials.some((item) => item?.openForm);
    if (isAnyFormOpen) {
      failureToast("Please save current open form");
    }
    return isAnyFormOpen;
  };
  const  addNewRowHandler = (isNonBarcoded=false) => {
    if (form?.businessArea === "")
      return failureToast(
        "Please select business area and other details first"
      );

    if (isAnyFormOpen(true)) return;

   isNonBarcoded===true?
   setSelectedNonBarcodedMaterials((prev) => [
    {
      openForm: true,
      qty: "",
      materialId: "",
    },
    ...prev,
  ])
   :setSelectedMaterials((prev) => [
      {
        openForm: true,
        qty: "",
        materialId: "",
      },
      ...prev,
    ]);
  };

  const updateBarcodeListForMaterial = (materialRowIndex, newBarcodeList) => {
    // newBarcodeList will be of the form [{barcode: 123, isIssued: false}]
    const updatedMaterials = [...selectedMaterials];
    updatedMaterials[materialRowIndex].barcodeList = newBarcodeList;
    setSelectedMaterials(updatedMaterials);
  }

  return (
    <>
      <Card className="m-3 border-radius-lg">
        <CardBody>
          <div className="d-flex align-items-center justify-content-between">
            <span className="heading-4 color-dark">
              Select material that you want to issue
            </span>
            <AButton
              onClick={()=>{
                addNewRowHandler()}}
              size="xs"
              variant="primary_filled"
              disabled={!isAllTransactionDetailsFilled||selectedNonBarcodedMaterials.length>0}
            >
              Add more material
            </AButton>
          </div>
          <div className="table-border-material">
            <AddMaterialTableV2
              rows={selectedMaterials}
              setRows={setSelectedMaterials}
              saveRowHandler={saveRowHandler}
              ref={listRef}
              businessArea={form?.businessArea}
              deleteHandler={deleteHandler}
              updateRowHandler={updateRowHandler}
              loading={loading}
              setLoading={setLoading}
              updateBarcodeListForMaterial={updateBarcodeListForMaterial}
              employeeDetailsForm={form}
            />
          </div>
          <div className="d-flex">
            <div
              className="heading-4 color-dark mb-2"
              style={{ fontSize: "16px" }}
            >
              {isDlp ? "Approval & Supporting Documents*" : "Attachment*"}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <UploadAttachments
              disabledBtn={!isAllTransactionDetailsFilled||selectedNonBarcodedMaterials.length>0}
              uploadFileHeader={
                isDlp
                  ? "Upload Approval & Supporting Documents"
                  : "Upload supporting document"
              }
              form={form?.barcoded}
              setFormHandler={setFormHandler}
              type={'barcoded'}
              uploadButtonProps={{ className: "ml-0 mb-3" }}
            />
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <AButton
              className="ml-0"
              variant="primary_filled"
              onClick={()=>issueStockHandler('barcoded')}
              disabled={isMaterialSelected(selectedMaterials)}
            >
              Issue Stock
            </AButton>
          </div>
        </CardBody>
      </Card>
      <Card className="m-3 border-radius-lg">
        <CardBody>
          <div className="d-flex align-items-center justify-content-between">
            <span className="heading-4 color-dark">
              Select material that you want to issue (Non-Barcoded Bulk Issuance)
            </span>
            <AButton
              onClick={()=>{
                addNewRowHandler(true)}}
              size="xs"
              variant="primary_filled"
              disabled={!isAllTransactionDetailsFilled||selectedMaterials.length>0}
            >
              Add more material
            </AButton>
          </div>
          <div className="table-border-material">
            <AddMaterialTableV2
              rows={selectedNonBarcodedMaterials}
              setRows={setSelectedNonBarcodedMaterials}
              saveRowHandler={saveRowNonBarcodedHandler}
              ref={listRef}
              businessArea={form?.businessArea}
              deleteHandler={deleteHandler}
              updateRowHandler={updateRowHandler}
              loading={loading}
              setLoading={setLoading}
              updateBarcodeListForMaterial={updateBarcodeListForMaterial}
              employeeDetailsForm={form}
              isNonBarcoded={true}
            />
          </div>
          <div className="d-flex">
            <div
              className="heading-4 color-dark mb-2"
              style={{ fontSize: "16px" }}
            >
              {isDlp ? "Approval & Supporting Documents*" : "Attachment*"}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <UploadAttachments
              disabledBtn={!isAllTransactionDetailsFilled||selectedMaterials.length>0}
              uploadFileHeader={
                isDlp
                  ? "Upload Approval & Supporting Documents"
                  : "Upload supporting document"
              }
              form={form?.nonBarcoded}
              type={'nonBarcoded'}
              setFormHandler={setFormHandler}
              uploadButtonProps={{ className: "ml-0 mb-3" }}
            />
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <AButton
              className="ml-0"
              variant="primary_filled"
              onClick={()=>issueStockHandler('nonBarcoded')}
              disabled={isMaterialSelected(selectedNonBarcodedMaterials)}
            >
              Issue Stock
            </AButton>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default SelectMaterialForm;
